import {Tooltip, Tabs} from 'antd';
import React, {useState} from 'react';
import '../../../css/cardPreview.css';
import {alarm_hint_tooltip_css as alarmHintTooltipCss} from "../../../utils/PublicConstant";
import Icon from '@ant-design/icons';
import alarmImg from  "../../../imagers/icon/alarm.png";
import CardEquipmentTooltip from "../../../utils/module/CardEquipmentTooltip";
import CardHighchartsPie from "../../../utils/module/CardHighchartsPie";
import CardDigitalModule from "../../../utils/module/CardDigitalModule";

interface CardData{
    param:any,
    realData:any,
    setItems:any,
    setActiveKey:any,
    items:any,
    viewTypeList:any,
    setViewTypeList:any;
    viewOperate:any;
}
const QY3AV52Preview: React.FC<CardData> = (cardData) => {
    const [realItems,setRealItems] = useState<any[]>([]);
    React.useEffect(() => {
        let newData = cardData.realData?.find((item:any) => item.id == cardData.param.id)?.data;
        if(newData != null && newData.devs.length > 0) {
            let devsList = new Array();
            for (let i = 0; i < newData.devs.length; i++) {
                let data = newData.devs[i];
                devsList.push(
                    {
                        label: <span className="preview-tabs-head-label">{data.name}</span>,
                        key: (i+1)+"",
                        children:<div className={"preview-tabs-content"}>
                            <table className="table table-borderless">
                                <tbody>
                                <tr>
                                    <td colSpan={2} width="50%" className="equipment-name-background">
                                        <CardEquipmentTooltip name={"设备名称"} nameLabel={"绕线电机交直流调速器"}/>
                                    </td>
                                    <td colSpan={2} width="50%">
                                        <CardEquipmentTooltip name={"型号规格"} nameLabel={""}/>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={2} width="50%">输入档位：{data.gearMerge}</td>
                                    <td colSpan={2} width="50%">电机转速：{data.speed}</td>
                                </tr>
                                <tr>
                                    <td width="25%" style={{borderRight:"0px"}}>定子电流：</td>
                                    <td style={{borderRight:"0px"}}>Iu：{data.currentU}</td>
                                    <td style={{borderRight:"0px"}}>Iv：{data.currentV}</td>
                                    <td style={{borderRight:"0px"}}>Iw：{data.currentW}</td>
                                </tr>
                                <tr>
                                    <td width="25%" style={{borderRight:"0px"}}>转子电流：</td>
                                    <td style={{borderRight:"0px"}}>Iu：{}</td>
                                    <td style={{borderRight:"0px"}}>Iv：{}</td>
                                    <td>Iw：{}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} width="50%">动作次数：{}</td>
                                    <td colSpan={2} width="50%">累计运行：{data.devRunTime}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} width="50%">晶闸管温度：{}</td>
                                    <td colSpan={2} width="50%">设备保养：{data.usageState}</td>
                                </tr>
                                <tr>
                                    <td colSpan={4}>
                                        <div className="alarm-info" id={"alarmDiv"}>
                                            <div className="alarm-info-title">故障提示：{data.fault}</div>
                                            <div className="alarm-info-content">
                                                <Tooltip title={data.state} color="#C9CACA" overlayInnerStyle={alarmHintTooltipCss} placement="bottom">
                                                    <div className="alarm-hint-tooltip-content"><span className="cancel-bold">{data.state}</span></div>
                                                </Tooltip>
                                            </div>
                                            <div style={{margin:"0px 3px"}}>
                                                <Icon component={() => (<img src={alarmImg} style={{width:"13px",height:"13px",display:data.fault === '0-无故障'?"none":"block"}}/>)}/>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="25%">
                                        <CardDigitalModule digitalName="一级切阻" digitalValue={data?.acce1}></CardDigitalModule>
                                    </td>
                                    <td width="25%">
                                        <CardDigitalModule digitalName="二级切阻" digitalValue={data?.acce2}></CardDigitalModule>
                                    </td>
                                    <td width="25%">
                                        <CardDigitalModule digitalName="三级切阻" digitalValue={data?.acce3}></CardDigitalModule>
                                    </td>
                                    <td width="25%">
                                        <CardDigitalModule digitalName="制动输出" digitalValue={data?.brake}></CardDigitalModule>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    }
                );
            }
            setRealItems(devsList);
        }
    },[cardData.realData]);
    return (
        <>
            <div className={"preview-tabs-head"} style={{height:"225px"}}>
                <Tabs defaultActiveKey="1" type="card" size={"middle"} tabBarStyle={{}} items={realItems}/>
            </div>
            <div className={"preview-tabs-head"} style={{marginTop:"10px"}}>
                <Tabs defaultActiveKey="1" type="card" size={"middle"} style={{}} onChange={(activeKey:string)=>{}}
                      items={[
                          {
                              key:"1",
                              label:<span className="preview-tabs-head-label">报警显示</span>,
                              children:<CardHighchartsPie param={cardData.param} seriesData={cardData.param.data?.alarmSumItems} />
                          }/*, {
                                label:<span className="preview-tabs-head-label">轨迹曲线</span>, key:"2",
                                children:<CardHighchartsSpline tickPositions={null} realData={[data?.currentU,data?.currentV,data?.currentW]} param={cardData.param} series={['U相电流','V相电流','W相电流']} />
                            }*/
                      ]}
                />
            </div>
        </>
    );
};

export default QY3AV52Preview;